/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'follow-tag': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data:
      '<g opacity=".9" clip-path="url(#clip0_5336_35857)"><path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.828 0c1.061 0 2.08.422 2.83 1.172l5.317 5.317a3.5 3.5 0 010 4.95l-3.535 3.536a3.5 3.5 0 01-4.95 0L1.171 9.657A4.002 4.002 0 010 6.828V3.5A3.5 3.5 0 013.5 0h3.328zm5.097 6.475a1 1 0 00-1.414 0L7.68 9.303l-1.06-1.06a1 1 0 00-1.414 1.414l1.768 1.768.076.068a1 1 0 001.338-.068l3.536-3.536a1 1 0 000-1.414zm-7.778-3.43c-.57 0-1.04.434-1.096.99l-.006.112.006.114a1.103 1.103 0 101.21-1.21l-.114-.006z" _fill="#fff"/></g><defs><clipPath id="clip0_5336_35857"><path pid="1" _fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs>'
  }
})
